module.exports = __webpack_public_path__ + "img/video-camera.76413d4d.svg";